import { createUseStyles } from 'react-jss'
import { WHITE, BLUE, DARK_BLUE } from '@omnilert/components'
export default createUseStyles({
  actionSheet: {
    padding: '20px 0',
    borderTopRightRadius: '30px',
    borderTopLeftRadius: '30px'
  },
  title: {
    textTransform: 'capitalize'
  },
  button: {
    alignItems: 'center',
    background: 'none',
    backgroundColor: BLUE,
    border: 'none',
    borderRadius: 20,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1), 0px 4px 15px rgba(30, 174, 255, 0.25), inset 0px -2px 0px rgba(255, 255, 255, 0.23)',
    color: WHITE,
    cursor: 'pointer',
    display: 'flex',
    font: 'inherit',
    fontSize: '14px',
    fontWeight: '500',
    justifyContent: 'center',
    letterSpacing: '-0.02em',
    outline: 'inherit',
    padding: '10px',
    textDecoration: 'none',
    width: '90px',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: DARK_BLUE,
      cursor: 'pointer'
    }
  },
  body: {
    padding: '20px 0'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& button:first-child': {
      marginRight: '10px'
    }
  },
  container: {
    backgroundColor: 'var(--header__emergency-button__background__color)',
    borderBottom: '2px solid var(--header__border__color)',
    height: '50px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px'
  },
  info: {
    textAlign: 'center',
    padding: '0 20px'
  },
  logo: {
    width: '150px',
    height: 'auto',
    objectFit: 'contain',
    marginBottom: '10px'
  }
})
